import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IAtendente } from 'src/app/pages/atendentes/data/atendente';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';

@Component({
  selector: 'app-tab-atendentes',
  templateUrl: './tab-atendentes.component.html',
  styleUrls: ['./tab-atendentes.component.scss']
})
export class TabAtendentesComponent {
  ERoleAdminString = ERoleAdminString;
  @Input() dadosPaginacaoAtendentes = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 4,
    totalPaginas: 0,
    itensTotal: 0
  };
  @Input() atendentes: IAtendente[] = [];
  @Input() companyId?: string;

  @Output() mudouPagina = new EventEmitter();
  @Output() mudouTamanhoPagina = new EventEmitter();
  @Output() recarregarListagem = new EventEmitter();

  constructor(private readonly router: Router) { }

  public abrirEmNovaAba(usuarioAdminId: string): void {
    const url = this.router.serializeUrl(this.router.createUrlTree([`/dash/atendentes/editar/${usuarioAdminId}`]));

    window.open(url, '_blank');
  }
}